
export const SUGGESTION_TYPE = {
  RELATIVE_FUTURE: 'future',
  RELATIVE_PRESENT_OR_PAST: 'present_or_past'
};

export function getRelativeDateSuggestions (dateConfiguration) {
  if (dateConfiguration?.relativeDateSuggestions?.length) {
    return dateConfiguration.relativeDateSuggestions.reduce(groupSuggestionsByIsFuture, createSuggestionMapping());
  }
  return [];
}

function groupSuggestionsByIsFuture (suggestionMapping, suggestion) {
  if (suggestion.amount > 0) {
    suggestionMapping[SUGGESTION_TYPE.RELATIVE_FUTURE].push(suggestion);
  } else {
    suggestionMapping[SUGGESTION_TYPE.RELATIVE_PRESENT_OR_PAST].push(suggestion);
  }
  return suggestionMapping;
}

function createSuggestionMapping () {
  return {
    [SUGGESTION_TYPE.RELATIVE_FUTURE]: [],
    [SUGGESTION_TYPE.RELATIVE_PRESENT_OR_PAST]: []
  };
}
